<app-spinner></app-spinner>
<div class="container-fluid">
    <h5 class="fw-bold mt-2">{{ translation.t('adminDashboard', 'title') }}</h5>
    <!-- <div class="row g-3 my-3">
        <div class="col-md-3">
            <a [routerLink]="['/sdp/admin/user-management']" class="text-decoration-none text-dark">
                <div class="card h-100 text-center">
                    <div class="card-body p-6">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                            <g clip-path="url(#clip0_498_3302)">
                                <path
                                    d="M25.2917 30.625V27.7083C25.2917 26.1612 24.6771 24.6775 23.5831 23.5835C22.4892 22.4896 21.0054 21.875 19.4583 21.875H7.79167C6.24457 21.875 4.76084 22.4896 3.66688 23.5835C2.57292 24.6775 1.95834 26.1612 1.95834 27.7083V30.625M34.0417 30.625V27.7083C34.0407 26.4159 33.6105 25.1603 32.8187 24.1388C32.0268 23.1173 30.9181 22.3877 29.6667 22.0646M23.8333 4.56458C25.0881 4.88586 26.2003 5.61561 26.9945 6.63879C27.7887 7.66197 28.2198 8.92038 28.2198 10.2156C28.2198 11.5109 27.7887 12.7693 26.9945 13.7925C26.2003 14.8156 25.0881 15.5454 23.8333 15.8667M19.4583 10.2083C19.4583 13.43 16.8467 16.0417 13.625 16.0417C10.4033 16.0417 7.79167 13.43 7.79167 10.2083C7.79167 6.98667 10.4033 4.375 13.625 4.375C16.8467 4.375 19.4583 6.98667 19.4583 10.2083Z"
                                    stroke="#226CE0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_498_3302">
                                    <rect width="35" height="35" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                        <h6 class="card-title mt-3">User Management</h6>
                        <p class="card-text small text-muted">Manage system users and permissions</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-3">
            <a [routerLink]="['/sdp/admin/dep-management']" class="text-decoration-none text-dark">
                <div class="card h-100 text-center">
                    <div class="card-body">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                            <g clip-path="url(#clip0_498_3309)">
                                <path
                                    d="M18 21.875C20.4163 21.875 22.375 19.9163 22.375 17.5C22.375 15.0838 20.4163 13.125 18 13.125C15.5838 13.125 13.625 15.0838 13.625 17.5C13.625 19.9163 15.5838 21.875 18 21.875Z"
                                    stroke="#226CE0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M28.7917 21.875C28.5976 22.3149 28.5396 22.8028 28.6254 23.2759C28.7112 23.749 28.9367 24.1855 29.2729 24.5292L29.3604 24.6167C29.6316 24.8876 29.8467 25.2093 29.9935 25.5633C30.1403 25.9174 30.2158 26.297 30.2158 26.6803C30.2158 27.0635 30.1403 27.4431 29.9935 27.7972C29.8467 28.1512 29.6316 28.4729 29.3604 28.7438C29.0896 29.015 28.7679 29.2301 28.4138 29.3769C28.0597 29.5237 27.6802 29.5992 27.2969 29.5992C26.9136 29.5992 26.5341 29.5237 26.18 29.3769C25.8259 29.2301 25.5042 29.015 25.2333 28.7438L25.1458 28.6563C24.8021 28.3201 24.3656 28.0946 23.8925 28.0088C23.4195 27.923 22.9315 27.9809 22.4917 28.175C22.0603 28.3599 21.6925 28.6669 21.4334 29.0581C21.1743 29.4494 21.0352 29.9079 21.0333 30.3771V30.625C21.0333 31.3986 20.7261 32.1405 20.1791 32.6874C19.6321 33.2344 18.8902 33.5417 18.1167 33.5417C17.3431 33.5417 16.6013 33.2344 16.0543 32.6874C15.5073 32.1405 15.2 31.3986 15.2 30.625V30.4938C15.1887 30.0111 15.0325 29.543 14.7516 29.1502C14.4707 28.7575 14.0782 28.4584 13.625 28.2917C13.1852 28.0976 12.6972 28.0397 12.2242 28.1255C11.7511 28.2112 11.3145 28.4368 10.9708 28.773L10.8833 28.8605C10.6125 29.1316 10.2908 29.3468 9.93671 29.4936C9.58263 29.6403 9.2031 29.7159 8.8198 29.7159C8.43651 29.7159 8.05697 29.6403 7.70289 29.4936C7.34882 29.3468 7.02714 29.1316 6.75626 28.8605C6.48508 28.5896 6.26995 28.2679 6.12317 27.9138C5.97639 27.5597 5.90084 27.1802 5.90084 26.7969C5.90084 26.4136 5.97639 26.0341 6.12317 25.68C6.26995 25.3259 6.48508 25.0043 6.75626 24.7334L6.84376 24.6459C7.17996 24.3022 7.40549 23.8656 7.49127 23.3926C7.57704 22.9195 7.51914 22.4316 7.32501 21.9917C7.14015 21.5604 6.8332 21.1925 6.44194 20.9334C6.05068 20.6743 5.5922 20.5352 5.12293 20.5334H4.87501C4.10146 20.5334 3.3596 20.2261 2.81262 19.6791C2.26563 19.1321 1.95834 18.3903 1.95834 17.6167C1.95834 16.8432 2.26563 16.1013 2.81262 15.5543C3.3596 15.0073 4.10146 14.7 4.87501 14.7H5.00626C5.48896 14.6888 5.9571 14.5325 6.34982 14.2516C6.74254 13.[... 2038 chars omitted ...]
                                    stroke="#226CE0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_498_3309">
                                    <rect width="35" height="35" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                        <h6 class="card-title mt-3">Department Config</h6>
                        <p class="card-text small text-muted">Manage departments and categories</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-3">
            <a [routerLink]="['/sdp/admin/escalation-matrix']" class="text-decoration-none text-dark">
                <div class="card h-100 text-center">
                    <div class="card-body">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                            <circle cx="18" cy="17.5" r="13.6667" stroke="#476CE0" stroke-width="4" />
                            <path d="M24.5625 17.5H18.25C18.1119 17.5 18 17.3881 18 17.25V12.3959" stroke="#476CE0"
                                stroke-width="4" stroke-linecap="round" />
                        </svg>
                        <h6 class="card-title mt-3">Escalation Matrix</h6>
                        <p class="card-text small text-muted">Configure complaint escalation rules</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-3">
            <a [routerLink]="['/sdp/admin/zone-word-mapping']" class="text-decoration-none text-dark">
                <div class="card h-100 text-center">
                    <div class="card-body">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                            <g clip-path="url(#clip0_498_3324)">
                                <path
                                    d="M12.1666 26.25L1.95831 32.0833V8.74996L12.1666 2.91663M12.1666 26.25L23.8333 32.0833M12.1666 26.25V2.91663M23.8333 32.0833L34.0416 26.25V2.91663L23.8333 8.74996M23.8333 32.0833V8.74996M23.8333 8.74996L12.1666 2.91663"
                                    stroke="#226CE0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_498_3324">
                                    <rect width="35" height="35" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                        <h6 class="card-title mt-3">Zone & Setup</h6>
                        <p class="card-text small text-muted">Manage geographical zones and wards</p>
                    </div>
                </div>
            </a>
        </div>
    </div> -->
    <div class="row g-3 mt-3 mb-3">
        <div class="col-md-3">
            <a [routerLink]="['/sdp/mc/total-greviance']" class="text-decoration-none text-dark">

                <div class="card h-100 p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">{{ translation.t('adminDashboard', 'totalComplaints') }}</h5>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path
                                d="M3.75 12.5H7.75V21.5H3.75V12.5ZM17.75 8.5H21.75V21.5H17.75V8.5ZM10.75 2.5H14.75V21.5H10.75V2.5Z"
                                fill="#7A7FA1" />
                        </svg>
                    </div>
                    <h4 class="mt-3">{{totalComplaints}}</h4>
                    <small class="text-muted">{{ translation.t('adminDashboard', 'acrossAllDept') }}</small>
                </div>
            </a>
        </div>
        <div class="col-md-3">
            <a [routerLink]="['/sdp/mc/pending-mc']" class="text-decoration-none text-dark">

                <div class="card h-100 p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">{{ translation.t('sidebar', 'pendingComp') }}</h5>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                            <circle cx="8.75" cy="8.5" r="8.5" fill="#FFAE00" />
                        </svg>
                    </div>
                    <h4 class="mt-3">{{pendingCount}}</h4>
                    <small class="text-warning">{{pendingPercentage}}% {{ translation.t('common', 'of') }} {{
                        translation.t('sidebar', 'totalGrievance') }}</small>
                </div>
            </a>
        </div>
        <div class="col-md-3">
            <a [routerLink]="['/sdp/officer/resolved-complaints']" class="text-decoration-none text-dark">

                <div class="card h-100 p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">{{ translation.t('sidebar', 'resolvedComp') }}</h5>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                            <circle cx="8.75" cy="8.5" r="8.5" fill="#00B74A" />
                        </svg>
                    </div>
                    <h4 class="mt-3">{{resolvedCount}}</h4>
                    <small class="text-success">{{resolvedPercentage}}% {{ translation.t('common', 'of') }} {{
                        translation.t('sidebar', 'totalGrievance') }}</small>
                </div>
            </a>
        </div>
        <!-- <div class="col-md-3">
                                <a [routerLink]="['/sdp/officer/closed-complaints']" class="text-decoration-none text-dark">

            <div class="card h-100 p-3">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">{{ translation.t('sidebar', 'closedComp') }}</h5>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <circle cx="8.75" cy="8.5" r="8.5" fill="#FF3D00" />
                    </svg>
                </div>
                <h4 class="mt-3">{{closedCount}}</h4>
                <small class="text-danger">{{closedPercentage}}% {{ translation.t('common', 'of') }} {{ translation.t('sidebar', 'totalGrievance') }}</small>
            </div>
                                </a>
        </div> -->
        <div class="col-md-3">
            <a [routerLink]="['/sdp/officer/escalated-complaints']" class="text-decoration-none text-dark">

                <div class="card h-100 p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">{{ translation.t('sidebar', 'escalatedComplaints') }}</h5>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                            <circle cx="8.75" cy="8.5" r="8.5" fill="#FF3D00" />
                        </svg>
                    </div>
                    <h4 class="mt-3">{{escalatedCount}}</h4>
                    <small class="text-danger">{{escalatedPercentage}}% {{ translation.t('common', 'of') }} {{
                        translation.t('sidebar', 'totalGrievance') }}</small>
                </div>
            </a>
        </div>
    </div>
    <div class="card mb-3">
        <div class="card-body">
            <h5 class="card-title mb-3" style="font-size: 20px;">
                <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="24" height="24" viewBox="0 0 24 24"
                    fill="none">
                    <path
                        d="M15 17.6396L16 17.6397V17.6396H15ZM14.6582 18.1143L14.9743 19.063L14.9744 19.0629L14.6582 18.1143ZM9.6582 19.7803L9.34209 18.8316L9.34198 18.8316L9.6582 19.7803ZM9 19.3066H8L8 19.3073L9 19.3066ZM8.70711 11.7071L9.41421 11L8.70711 11.7071ZM15.2929 11.7071L14.5858 11L15.2929 11.7071ZM19.7071 7.29289L20.4142 8L19.7071 7.29289ZM19.7071 7.29289L19 6.58579L14.5858 11L15.2929 11.7071L16 12.4142L20.4142 8L19.7071 7.29289ZM15 12.4142H14V17.6396H15H16V12.4142H15ZM15 17.6396L14 17.6396C14 17.4254 14.1369 17.2339 14.342 17.1656L14.6582 18.1143L14.9744 19.0629C15.5878 18.8585 16 18.2843 16 17.6397L15 17.6396ZM14.6582 18.1143L14.3421 17.1655L9.34209 18.8316L9.6582 19.7803L9.97432 20.729L14.9743 19.063L14.6582 18.1143ZM9.6582 19.7803L9.34198 18.8316C9.66442 18.7241 9.99977 18.9636 10 19.306L9 19.3066L8 19.3073C8.00068 20.3319 9.00467 21.0522 9.97443 20.729L9.6582 19.7803ZM9 19.3066H10V12.4142H9H8V19.3066H9ZM8.70711 11.7071L9.41421 11L5 6.58579L4.29289 7.29289L3.58579 8L8 12.4142L8.70711 11.7071ZM4 6.58579H5V5H4H3V6.58579H4ZM5 4V5H19V4V3H5V4ZM20 5H19V6.58579H20H21V5H20ZM19 4V5H20H21C21 3.89543 20.1046 3 19 3V4ZM4 5H5V5V4V3C3.89543 3 3 3.89543 3 5H4ZM4.29289 7.29289L5 6.58579H5H4H3C3 7.11622 3.21071 7.62493 3.58579 8L4.29289 7.29289ZM9 12.4142H10C10 11.8838 9.78929 11.3751 9.41421 11L8.70711 11.7071L8 12.4142V12.4142H9ZM15.2929 11.7071L14.5858 11C14.2107 11.3751 14 11.8838 14 12.4142H15H16V12.4142L15.2929 11.7071ZM19.7071 7.29289L20.4142 8C20.7893 7.62493 21 7.11622 21 6.58579H20H19L19.7071 7.29289Z"
                        fill="#33363F" />
                </svg>{{ translation.t('adminDashboard', 'filterComplaints') }}
            </h5>
            <div class="row g-3 mt-3">
                <div class="col-md-3">
                    <span>{{ translation.t('preview', 'complaintDepartment') }}</span>
                    <ng-select [items]="allDepartment" bindLabel="department_name" bindValue="department_name"
                        [(ngModel)]="selectedDepartment"
                        placeholder="{{ translation.t('adminDashboard', 'selectDepartment') }}"
                        (change)="onFilterChange()" [searchable]="true" [clearable]="true">
                    </ng-select>

                </div>
                <div class="col-md-3">
                    <span>{{ translation.t('preview', 'zone') }}</span>
                    <ng-select [(ngModel)]="selectedZone" [items]="allZones"
                        placeholder="{{ translation.t('adminDashboard', 'allZones') }}" (change)=" onFilterChange()"
                        [clearable]="true" bindLabel="zone" [searchable]="true" bindValue="zone">
                    </ng-select>
                </div>

                <div class="col-md-3">
                    <span>{{ translation.t('common', 'status') }}</span>
                    <ng-select [(ngModel)]="selectedStatus" [items]="statusArr"
                        placeholder="{{ translation.t('adminDashboard', 'allStatuses') }}" bindLabel="value"
                        bindValue="code" (change)=" onFilterChange()" [clearable]="true">
                    </ng-select>
                </div>

                <div class="col-md-3">
                    <label>{{ translation.t('officerDashboard', 'createdDate') }}</label>
                    <ng-select [items]="availableCreateDates" bindLabel="create_date" bindValue="create_date"
                        [(ngModel)]="selectedcreate_date" (change)="onFilterChange()"
                        placeholder="{{ translation.t('adminDashboard', 'allDates') }}" [clearable]="true">
                    </ng-select>
                </div>

                <div class="col-12 mt-4 d-flex justify-content-end gap-2">
                    <button class="btn btn-outline-secondary" (click)="clearFilter()">{{ translation.t('adminDashboard',
                        'clearFilter') }}</button>
                </div>
            </div>

            <hr class="my-4">

            <h5 class="card-title mb-4" style="font-size: 20px;">{{ translation.t('adminDashboard',
                'complaintsOverview') }}</h5>

            <!-- Global Search Input -->
            <div class="row mb-3">
                <div class="col-md-8 col-12">
                    <input type="text" class="form-control fontAwesome" style="padding: 8px;" [(ngModel)]="searchText"
                        (keyup)="onFilterChange()"
                        placeholder="{{ translation.t('adminDashboard', 'searchPlaceholder') }}">
                </div>
                <div class="col-md-4 col-12 d-flex gap-2 justify-content-end mt-2 mt-md-0">
                    <button class="btn  " style="background-color: #1D6F42; color: white;" (click)="exportToExcel()">
                        <i class="fa fa-file-excel-o me-1"></i> Excel
                    </button>
                    <button class="btn  " style="background-color: #f44336; color: white;" (click)="exportToPDF()">
                        <i class="fa fa-file-pdf-o me-1"></i> PDF
                    </button>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table table-bordered w-100">
                    <thead>
                        <tr>
                            <th>{{ translation.t('common', 'id') }}</th>
                            <th>{{ translation.t('preview', 'complaintDepartment') }}</th>
                            <th>{{ translation.t('preview', 'zone') }}</th>
                            <th>{{ translation.t('adminDashboard', 'fullName') }}</th>
                            <th>{{ translation.t('adminDashboard', 'mobileNo') }}</th>
                            <th>{{ translation.t('common', 'status') }}</th>
                            <th>{{ translation.t('officerDashboard', 'createdDate') }}</th>
                            <th style="text-align: center !important;">{{ translation.t('common', 'daysOpen') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let comp of pagedComplaints; let i = index">
                            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
                            <td>{{comp.departments}}</td>
                            <td>{{ comp.zone }}</td>
                            <td>{{ comp.full_name }}</td>
                            <td>{{ comp.mobile_no }}</td>
                            <td>
                                <span class="ba" style="border-radius: 5px;" [ngStyle]="{
                  'background-color': 
                    comp.status === 'PENDING' ? '#FEF3C7' :
                    comp.status === 'GENERATED' ? '#FFD5CA' :
                    comp.status === 'RESOLVED' ? '#A2FFD0' :
                    comp.status === 'CLOSED' ? '#E2E2E2' : '',
                  'color':
                    comp.status === 'PENDING' ? '#601B02' :
                    comp.status === 'GENERATED' ? '#930404' :
                    comp.status === 'RESOLVED' ? '#05760C' :
                    comp.status === 'CLOSED' ? '#33363F' : ''
                }">
                                    {{ comp.status }}
                                </span>
                            </td>
                            <td>{{ comp.create_date }}</td>
                            <td class="text-danger" style="text-align: center !important;">{{ comp.number_of_open_days
                                }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-end align-items-end mt-3 flex-wrap me-3 mb-2">
            <span style="color: #6D6D6D; font-size: 14px; font-weight: 300; line-height: 21px;">
                {{ translation.t('common', 'showing') }} {{ pagedComplaints.length }} {{ translation.t('common', 'of')
                }} {{ filteredComplaints.length }} {{ translation.t('sidebar', 'complaints') }}
            </span>

            <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
                <label class="me-1">{{ translation.t('common', 'perPage') }}:</label>
                <select [(ngModel)]="pageSize" (change)="changePageSize()" class="form-select form-select-sm w-auto">
                    <option *ngFor="let size of page_list" [value]="size">{{ size }}</option>
                </select>

                <button class="btn-sm fw-bold px-3 py-1 me-2" (click)="prevPage()" [disabled]="currentPage === 1"
                    title="Previous Page">
                    &lt;
                </button>

                <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

                <button class="me-2 btn-sm fw-bold px-3 py-1" (click)="nextPage()"
                    [disabled]="currentPage === totalPages">
                    &gt;
                </button>
            </div>
        </div>

    </div>
</div>